import React from 'react';
import PropTypes from 'prop-types';
import { YourFeaturedNews } from './YourFeaturedNews';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
const theme = createTheme('uhc', { enterpriseFont: true });

export const Widget = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <YourFeaturedNews {...props} />
    </ThemeProvider>
  );
};

Widget.displayName = 'utility/YourFeaturedNewsWidget';

Widget.propTypes = {
  data: PropTypes.shape({}),
};

Widget.defaultProps = {
  data: {},
};
